export const blogPosts = [
//   {
//     id: 1,
//     title: "Building Scalable Web Applications with React and Node.js",
//     excerpt: "Learn best practices for creating scalable web applications using modern React patterns and Node.js backend architecture.",
//     thumbnail: "https://images.unsplash.com/photo-1627398242454-45a1465c2479?w=800&h=600&fit=crop",
//     category: "Web Development",
//     date: "2024-12-15",
//     readTime: "8 min read",
//     tags: ["React", "Node.js", "Scalability"]
//   },
];
